<template>
  <div class="opera-btn-group " :class="{up:!showSearch}">
    <el-form v-show="showSearch" class="advanced-query-form clearfix"
             onsubmit="return false">
      <el-row>
        <el-col :span="8">
          <oms-form-row :span="6" label="货主订单号">
            <oms-input placeholder="请输入货主订单号" type="text" v-model="searchCondition.orderNo"></oms-input>
          </oms-form-row>
        </el-col>
        <el-col :span="8">
          <oms-form-row label="推送单位" :span="6">
             <org-select placeholder="请输入名称/拼音首字母缩写/系统代码搜索推送单位" :remote-method="queryUpOrgList"
                         v-model="searchCondition.orgId" :list="upOrgList"/>
          </oms-form-row>
        </el-col>
        <el-col :span="8">
          <oms-form-row label="推送时间" :span="5">
            <el-col :span="24">
              <el-date-picker
                v-model="pushTimes"
                type="datetimerange"
                placeholder="请选择"
                :default-time="['00:00:00', '23:59:59']">
              </el-date-picker>
            </el-col>
          </oms-form-row>
        </el-col>
        <el-col :span="8">
          <oms-form-row label="" :span="5">
            <el-button class="ml-15" type="primary" native-type="submit" @click="searchInOrder">查询</el-button>
            <el-button native-type="reset" @click="resetSearchForm">重置</el-button>
          </oms-form-row>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
  import MethodsMix from '@/mixins/methodsMinix';

  export default {
    props: {
      bizTypes: Array
    },
    mixins: [MethodsMix],
    data() {
      return {
        showSearch: true,
        pushTimes: '',
        searchCondition: {
          orgId: '',
          orderNo: '',
          startTime: '',
          endTime: ''
        }
      };
    },
    methods: {
      queryDhsBatchNumbers(val) {
        if (!this.searchCondition.goodsId) {
          this.batchNumberList = [];
          this.$notify.info('请选择货品主档');
          return;
        }
        this.queryDhsBatchNumberList({
          keyWord: val,
          goodsId: this.searchCondition.goodsId
        });
      },
      searchInOrder: function () {// 搜索
        this.searchCondition.startTime = this.$formatAryTime(this.pushTimes, 0, 'YYYY-MM-DD HH:mm:ss');
        this.searchCondition.endTime = this.$formatAryTime(this.pushTimes, 1, 'YYYY-MM-DD HH:mm:ss');
        this.$emit('search', this.searchCondition);
      },
      resetSearchForm: function () {// 重置表单
        let temp = {
          orgId: '',
          orderNo: '',
          startTime: '',
          endTime: ''
        };
        this.pushTimes = '';
        Object.assign(this.searchCondition, temp);
        this.$emit('search', temp);
      }
    }
  };
</script>
